import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ViewChild,
  ElementRef
} from '@angular/core';
import { IMyOptions, MDBDatePickerComponent, ClockPickerComponent } from 'ng-uikit-pro-standard';
import {ElementsService} from '../elements.service'

@Component({
  selector: 'as-form',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss']
})
export class FormsComponentElements implements OnInit {

  public myDatePickerOptions: IMyOptions = {
    // Your options
    };

  @Input() type;
  @Input() display;
  @Input() placeholder = '';
  @Input() label;
  @Input() role;
  @Input() disabled = false;
  @Input() required = false;
  @Input() name : string;
  @Input() fieldName : string;
  @Input() value;
  @Input() data;
  @Input() selectedValue;
  @Input() options;
  @Input() checked;
  @Input() size;


  @Input() datePickerOptions;
  @Input() minlength;
  @Input() validation;
  @Input() formModel;
  @Input() icon : string;

  id;
  formValidation = [];
  validationResults = [];
  validatefail;
  inputs;
  model;
  valid = [];



  selectedDate = {date: {year: 2019, month: 5, day: 8}};

  @Output() outputData =  new EventEmitter();
  @Output() validationStatus =  new EventEmitter();

  @ViewChild('textInput', {static:false}) textInput : ElementRef;


  constructor(private _elementService : ElementsService) {
   }



  output(data){
    this.outputData.emit(data);
  }

  handleChange(value){
    this.outputData.emit(value.target.value);
  }



 uuid() {
    this.id= crypto.getRandomValues(new Uint32Array(4)).join('-');
  }

  onRangeValueChange(value){
    this.outputData.emit(value);
  }

  onSubmit(){

    this.validationStatus.emit(this._elementService.getValidation(this.formModel));

  }

  //reatime, on field interraction
  validate(value){

    this.outputData.emit(value)
    this.validatefail = this._elementService.validate(this.validation, value);

  }

  //mark faild validation message
  initValidation(value, inputs?){

    let clearValidation =true;
    console.log(value)
    inputs.forEach((inputs, inx) => {

      value.forEach((e, i)=>{
       if (inputs.id == e.id){

        if(e.validationFail){
          inputs.validatefail = true
          clearValidation = false;
        }
       }

      })
    });

   return clearValidation;
  }




  ngOnInit() {
      this.uuid();
      // Text/textarea: seed from [value] so callers can pass an initial string.
      // Check/switch/etc.: seed from [checked] (existing behaviour).
      if (this.type === 'text' || this.type === 'textarea') {
        this.model = this.value != null ? this.value : '';
      } else {
        this.model = this.checked;
      }
      this.required = (this.validation !== undefined) ? true: false;
      this._elementService.setValidation(this.id, this.validation)
  }

}
